import React, { forwardRef } from 'react';
import { slidePropTypes } from './props';

const Slide = forwardRef(({
  children,
  isActive = false,
  isHidden = false,
  minWidth = undefined,
  onKeyDown = undefined,
  onMouseDown = undefined,
  onMouseUp = undefined,
  onTouchStart = undefined,
  onTouchEnd = undefined,
  width = undefined,
}, ref) => {
  const handleMouseDown = (event) => {
    if (onMouseDown) onMouseDown(event);
  };

  const handleMouseUp = (event) => {
    if (onMouseUp) onMouseUp(event);
  };

  const handleKeyDown = (event) => {
    if (onKeyDown) onKeyDown(event);
  };

  const handleTouchStart = (event) => {
    if (onTouchStart) onTouchStart(event);
  };

  const handleTouchEnd = (event) => {
    if (onTouchEnd) onTouchEnd(event);
  };

  const style = {};
  if (minWidth) style.minWidth = `${minWidth}px`;
  if (width) style.width = `${width}px`;

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
      ref={ref}
      aria-labelledby={children.props.id}
      aria-roledescription="slide"
      aria-hidden={isHidden}
      className={`slide ${isActive ? 'active' : ''}`}
      onKeyDown={handleKeyDown}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onTouchEnd={handleTouchEnd}
      onTouchStart={handleTouchStart}
      style={style}
      tabIndex="-1"
      role="option"
      aria-selected={isActive}
    >
      {children}
    </div>
  );
});

export default Slide;

Slide.propTypes = slidePropTypes;
